import { isEmpty } from 'lodash-es';
import type { Key } from 'react';

import type { ReportingBlockDto, ReportingPackageDto } from '@src/api';

type PublicationRegisterType = ReportingBlockDto &
  ReportingPackageDto & { id: number; children: PublicationRegisterType[] };

export const filterTree = <T extends { children?: T[] }>(filter: string, list: T[] = [], key = 'name'): T[] =>
  list.filter((item) => {
    if ((item as never)[key] === filter) {
      return true;
    } else if (item.children) {
      item.children = filterTree(filter, item.children, key);
      return !isEmpty(item.children);
    }
  });

const sortTreeItem = <T extends { name?: string; children?: T[] }>(list: T[]): T[] =>
  [...list].sort(({ name: a }, { name: b }) => (a && b ? (a < b ? -1 : a > b ? 1 : 0) : 0));

export const sortRecursiveByName = <T extends { children?: T[] }>(list: T[]): T[] =>
  sortTreeItem(list).map((item) =>
    !!item?.children ? { ...item, children: sortRecursiveByName(item.children) } : { ...item },
  );

// Находит родителя узла
export const getParent = (key: Key, tree: PublicationRegisterType[]): PublicationRegisterType | undefined => {
  let parent;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.id === key)) {
        parent = node;
      } else {
        const found = getParent(key, node.children);
        if (found) {
          return found;
        }
      }
    }
  }

  return parent;
};
